var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import ReactDOM from 'react-dom';

import * as Sentry from '@sentry/react';

import { BrowserTracing } from '@sentry/tracing';

import { AppContainer } from 'react-hot-loader';

import App from "./App";

import "./App/sockets";

if (window.SENTRY_APP_DSN) {
  Sentry.init({
    release: window.UWAZI_VERSION,
    environment: window.UWAZI_ENVIRONMENT,
    dsn: window.SENTRY_APP_DSN,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.1
  });
}

const render = (Component) => {
  ReactDOM.hydrate( /*#__PURE__*/
  _jsx(AppContainer, {}, void 0, /*#__PURE__*/
  _jsx(Component, {})),

  document.getElementById('root'));

};

render(App);

if (module.hot) {
  module.hot.accept('./App', () => {
    const nextApp = require("./App");
    render(nextApp);
  });
}